import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/(auth)/recovery/page.tsx");
